import styled from 'styled-components';

export const PhoneNumberContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  font-family: inherit;
  gap: 0;
`;
